(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    // Initialize collection filter drawer component
  if (!customElements.get('collection-filter-drawer')) {
    const style = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = '{{ "collection-filter-drawer.css" | asset_url }}';
    document.head.appendChild(style);
  }

  // Initialize drawer toggle buttons if DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', (e) => {
      const button = e.target.closest('[data-filter-drawer-toggle]');
      if (!button) return;
      e.preventDefault();
      const filterDrawer = document.querySelector('dialog-component[id="filters-drawer"]');
      if (filterDrawer && typeof filterDrawer.showDialog === 'function') {
        filterDrawer.showDialog();
      }
    });
  }, { once: true });
  } catch(e) { console.error(e); }
})();

})();
